import React from 'react';
import { CharacterBlock } from './CharacterStyles';
import { imageUrl, posterSize } from '../api';
import castPlaceHolder from '../../imgs/svgs/castPlaceHolder.svg';

const Character = (props) => {
  const { profile_path, character, name } = props.cast;
  let castPic;
  if (profile_path) {
    castPic = `${imageUrl}${posterSize.s}${profile_path}`;
  } else {
    castPic = castPlaceHolder;
  }
  return (
    <CharacterBlock className='character'>
      <img src={castPic} alt={name} />
      <div className='details'>
        <h5>{name}</h5>
        <p>{character}</p>
      </div>
    </CharacterBlock>
  );
};

export default Character;
